<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-col w-full mt-base">
          <vs-card class="p2">
            <div slot="header">
              <div class="vx-row m-2">
                <h5>Pengguna</h5>
              </div>
            </div>
            <form>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Nama</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <vs-input class="w-full" type="text" v-model="updateData.nama" name="nama" v-validate="'required|min:10'"/>
                  <span class="text-danger text-sm" v-show="errors.has('nama')">{{ errors.first('nama') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>NIP</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <vs-input class="w-full" type="text" v-model="updateData.nip" name="nip" v-validate="'required|min:3'"/>
                  <span class="text-danger text-sm" v-show="errors.has('nip')">{{ errors.first('nip') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Bidang</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <v-select :options="listBidang" v-model="selectedBidang" name="bidang" v-validate="'required'"/>
                  <span class="text-danger text-sm" v-show="errors.has('bidang')">{{ errors.first('bidang') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Jabatan</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <v-select :options="listJabatan" v-model="selectedJabatan" name="jabatan" v-validate="'required'"/>
                  <span class="text-danger text-sm" v-show="errors.has('jabatan')">{{ errors.first('jabatan') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Golongan</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <v-select :options="listGolongan" v-model="selectedGolongan" name="golongan" v-validate="'required'"/>
                  <span class="text-danger text-sm" v-show="errors.has('golongan')">{{ errors.first('golongan') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Role</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <v-select :options="listRole" v-model="selectedRole" name="role" v-validate="'required'"/>
                  <span class="text-danger text-sm" v-show="errors.has('role')">{{ errors.first('role') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Alamat</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <vs-input class="w-full" type="text" v-model="updateData.alamat" name="alamat" v-validate="'required|min:5'"/>
                  <span class="text-danger text-sm" v-show="errors.has('alamat')">{{ errors.first('alamat') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Telepon</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <vs-input class="w-full" type="text" v-model="updateData.telepon" name="telepon" v-validate="'required|min:11'"/>
                  <span class="text-danger text-sm" v-show="errors.has('telepon')">{{ errors.first('telepon') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Status</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <v-select :options="listStatus" v-model="selectedStatus" name="status" v-validate="'required'"/>
                  <span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Tanggal Lahir</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <datepicker
                    v-model="updateData.tgl_lahir"
                    :format="'yyyy-MM-dd'"
                    name="tgl_lahir"
                    v-validate="'required'"
                  >
                  </datepicker>
                  <span class="text-danger text-sm" v-show="errors.has('tgl_lahir')">{{errors.first("tgl_lahir")}}</span>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-5/6 w-full ml-auto">
                  <vs-button 
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-check"
                    class="mb-4 self-end"
                    size="medium"
                    @click="submitPengguna()"
                    >Update Data
                  </vs-button>
                </div>
              </div>
            </form>
          </vs-card>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/4">
        <vs-button
          @click="$router.push({name: 'manajemen-user-detail', params : {uuid : $route.params.uuid}})"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          class="mb-4 self-end"
          size="small"
          > Kembali
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import {FIND} from '@/query/pengguna';
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import {UPDATE} from '@/query/pengguna';
import {GET_ALL as ALL_GOLONGAN} from '@/query/golongan';
import {GET_ALL as ALL_BIDANG} from '@/query/bidang';
import {GET_ALL as ALL_JABATAN} from '@/query/jabatan';

export default {
  data() {
    return {
      pengguna : {},
      updateData : {
        nama : '',
        nip : '',
        jabatan_id : '',
        golongan_id : '',
        alamat : '',
        telepon : '',
        status : '',
        tgl_lahir : '',
        role : ''
      },
      selectedBidang : {value : '', label : ''},
      selectedGolongan : {value : '', label : ''},
      selectedJabatan : {value : '', label : ''},
      selectedStatus : {value : '', label : ''},
      selectedRole : {value : '', label : ''},
      listBidang : [],
      listGolongan : [],
      listJabatan : [],
      listRole : [
        {value : 'kepala_opd', label : 'Kepala OPD'},
        {value : 'pegawai', label : 'Pegawai'},
        {value : 'pengendali_surat', label : 'Pengendali Surat'},
        {value : 'operator_surat', label : 'Operator Surat'}
      ],
      listStatus : [
        {value : true, label : 'Aktif'},
        {value : false, label : 'Tidak Aktif'},
      ]
    };
  },
  mounted(){
    this.assignData();
  },
  created(){
    this.getGolongan();
    this.getBidang();
    this.getJabatan();
  },
  apollo : {
    pengguna : {
      query : FIND,
      update : (data) => data.pengguna,
      variables(){
        return {
          where: { column : 'UUID', value : this.$route.params.uuid }
        }
      }
    }
  },
  methods : {
    async submitPengguna(){
      await this.$validator.validateAll().then(result => {
        if(result){
          this.updateData.tgl_lahir = moment(this.updateData.tgl_lahir).format("YYYY-MM-DD");
          this.$apollo.mutate({
            mutation : UPDATE,
            variables : {
              id : this.pengguna.id,
              input : {
                ...this.updateData,
              }
            }
          })
          .then(() => {
            this.$vs.notify({
              title: 'Berhasil melakukan update pengguna.',
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position : "top-right"
            });
            window.setTimeout(() => {
              this.$router.push({name : 'manajemen-user-detail',params : {uuid : this.$route.params.uuid}});
            },700);
          })
          .catch((error) => {
            console.log(error);
            if(error.graphQLErrors[0].extensions.validation.length != 0){
              this.$vs.notify({
                title: error.graphQLErrors[0].extensions.validation,
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
                position : "top-right"
              });
            }
            else{
              console.error(error);
              this.$vs.notify({
                title: 'Terjadi kesalahan, silahkan hubungi tim IT.',
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
                position : "top-right"
              });
            }
          });
        }
        else{
          this.$vs.notify({
            title: 'Untuk memperbaharui data pengguna, silahkan lengkapi form terlebih dahulu !',
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position : "top-right"
          });
        }
      });
    },
    assignData(){
      Object.keys(this.updateData).map(item => {
        if(this.pengguna.hasOwnProperty(item)){
          this.updateData[item] = this.pengguna[item];
        }
      });

      this.selectedBidang.value = this.pengguna.jabatan.bidang.id;
      this.selectedBidang.label = this.pengguna.jabatan.bidang.nama;
      this.selectedGolongan.value = this.pengguna.golongan.id;
      this.selectedGolongan.label = this.pengguna.golongan.nama;
      this.selectedJabatan.value = this.pengguna.jabatan.id;
      this.selectedJabatan.label = this.pengguna.jabatan.nama;
      this.selectedStatus.value = this.pengguna.status;
      this.selectedStatus.label = this.pengguna.status ? 'Aktif' : 'Tidak Aktif';
      this.selectedRole.value = this.pengguna.role
      this.selectedRole.label = this.pengguna.role
    },
    async getGolongan() {
      const perpage = 1000;
      const response = await this.$apollo.query({
        query: ALL_GOLONGAN,
        variables: {
          perPage: perpage,
          where: { column: "STATUS", value: 1 },
        }
      });
      response.data.golongan.data.map(item => {
        this.listGolongan.push({ value: item.id, label: `${item.nama} - ${item.keterangan}` });
      });
    },
    async getBidang(){
      const perpage = 1000;
      const response = await this.$apollo.query({
        query: ALL_BIDANG,
        variables: {
          perPage: perpage,
          where: { column: "INSTANSI_ID", value: 1 }, // INSTANSI DPMPTSP
        }
      });
      response.data.bidang.data.map(item => {
        this.listBidang.push({ value: item.id, label: item.nama });
      });
    },
    async getJabatan(){
      const perpage = 1000;
      var where = {column : 'STATUS', value : 1};
      if(this.selectedBidang.value.length != 0){
        where = {column : 'BIDANG_ID', value : this.selectedBidang.value};
      }

      const response = await this.$apollo.query({
        query: ALL_JABATAN,
        variables: {
          perPage: perpage,
          where: where, 
        }
      });
      this.listJabatan = [];
      response.data.jabatan.data.map(item => {
        this.listJabatan.push({ value: item.id, label: item.nama });
      });
    },
  },
  components: {
    "v-select": vSelect,
    Datepicker
  },
  watch : {
    selectedBidang : {
      deep : true,
      handler(){
        this.getJabatan();
      }
    },
    selectedGolongan : {
      deep : true,
      handler(){
        this.updateData.golongan_id = this.selectedGolongan.value
      }
    },
    selectedJabatan : {
      deep : true,
      handler(){
        this.updateData.jabatan_id = this.selectedJabatan.value
      }
    },
    selectedStatus : {
      deep : true,
      handler(){
        this.updateData.status = this.selectedStatus.value
      }
    },
  }
};
</script>
